const Configs = {
  CONTENTS: {
    GROUP_NAME: {
      SEO_DETAILS: 'seo-details',
      COUNTDOWN_BANNER: 'COUNTDOWN_BANNER',
      COMIC: 'COMIC',
      WEBSITE_VIDEO_GALLERY: 'WEBSITE_VIDEO_GALLERY'
    }
  },
  API: {
    BASE_URL: import.meta.env.VITE_API_URL || 'https://api.gimmefy.ai/v2'
  },
  NEWSLETTER: {
    SUBSCRIBER_COUNT: 4600, // LinkedIn newsletter subscribers - update manually
    FALLBACK_LAUGHS: '50K+'
  }
};

export default Configs;
